export enum StatusScreen {
  Review = 0,
  Manual = 1,
}
